export default __webpack_public_path__ + "static/media/s-1.e8944d5d.jpg";